import Vue from 'vue';
import Router from 'vue-router';

import AttendanceTracking from './views/AttendanceTracking';
import Login from './views/Login';
import ResetPassword from './views/ResetPassword';
import ChangePassword from './views/ChangePassword';
import Alert from './views/Alert';
import VideoDashboardCams from './views/video/dashboard/Cams';
import VideoCam from './views/video/dashboard/Cam';
import CameraSettings from './views/CameraSettings';
import Events from './views/Events';
import AccessLogs from './views/AccessLogs';
import UserManagement from './views/UserManagement';
import MyProfile from './views/MyProfile';
import StudentManagement from './views/StudentManagement';
import Tutorial from './views/Tutorial';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      redirect: { path: '/video/dashboard/cams' },
    }, {
      path: '/login',
      name: 'login',
      component: Login,
    }, {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
    }, {
      path: '/change-password/:token',
      // TODO:
      // path: '/change-password/token123123123123',
      name: 'change-password',
      component: ChangePassword,
    }, {
      path: '/attendance/tracking',
      name: 'attendance-tracking',
      component: AttendanceTracking,
    }, {
      path: '/alert/:id',
      name: 'alert',
      component: Alert,
    }, {
      path: '/video/dashboard/cams',
      name: 'video',
      component: VideoDashboardCams,
    }, {
      path: '/video/dashboard/cam/:id',
      name: 'video-cam',
      component: VideoCam,
    }, {
      path: '/camera/settings',
      name: 'camera',
      component: CameraSettings,
    }, {
      path: '/events',
      name: 'events',
      component: Events,
    }, {
      path: '/access-logs',
      name: 'access-logs',
      component: AccessLogs,
    }, {
      path: '/user-management',
      name: 'user-management',
      component: UserManagement,
    }, {
      path: '/my-profile',
      name: 'my-profile',
      component: MyProfile,
    }, {
      path: '/student-management',
      name: 'student-management',
      component: StudentManagement,
    }, {
      path: '/tutorial',
      name: 'tutorial',
      component: Tutorial,
    },
  ],
});

export default router;
